import { Box, Typography, useMediaQuery } from '@mui/material';
import FitnessCenterOutlinedIcon from '@mui/icons-material/FitnessCenterOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import MetricValue from './MetricValue';
import { t } from '../../i18n';

const metrics = [
    ['exercises_completed', 'Exercícios realizados', FitnessCenterOutlinedIcon],
    ['alerts_generated', 'Alertas gerados', NotificationsActiveOutlinedIcon],
    ['questionnaires_answered', 'Questionários respondidos', FactCheckOutlinedIcon]
];

export default function MonthlyActivity() {
    const short = useMediaQuery('(max-height:499.95px)');
    return <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <Typography component="h2" variant="h4" color="primary.main" sx={{ fontSize: { xs: 15, sm: 17 } }}>
            {t('Atividade mensal')}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
            {t('Estes indicadores estão em preparação.')}
        </Typography>
        <Box sx={{
            flex: 1, minHeight: 0, display: 'grid', mt: short ? 0.5 : 1.5, alignItems: 'center',
            gridTemplateColumns: short ? 'repeat(3, minmax(0, 1fr))'
                : { xs: 'minmax(0, 1fr)', sm: 'repeat(3, minmax(0, 1fr))' },
            gap: short ? 1 : { xs: 1.5, sm: 2 }
        }}>
            {metrics.map(([key, label, Icon]) =>
                <MetricValue key={key} value="—" label={label} icon={Icon} short={short} large />)}
        </Box>
    </Box>;
}
